export default {
	methods: {
		getIconNameFromClass(iconClass) {
			if (!iconClass) {
				return;
			}

			let matches = iconClass.match(/bi bi\-(.*)/);
			if (!matches || matches.length < 2) {
				return;
			}

			return matches[1];
		}
	}
}